import { withKlarnaPaymentMethodProps } from 'viewModel/klarna/klarnaPaymentMethod/withKlarnaPaymentMethodProps';
import KlarnaPaymentMethod from 'components/Klarna/KlarnaPaymentMethod/KlarnaPaymentMethod';

export default withKlarnaPaymentMethodProps(KlarnaPaymentMethod);
